<template>
    <EDCHeader :logo_upc="true" />
    <div class="news-body">
        <div class="news-body__left">
            <h3 class="news-body__left-title">Municipio:</h3>
            <div class="news-municipio__list">
                <p
                    @click="onFilterMunicipio(municipio.code)"
                    class="news-municipio" 
                    :class="[filtered == municipio.code ? 'active' : '']" 
                    v-for="municipio in municipio_list"
                    :key="municipio.code">
                    {{ municipio.name }}
                </p>
            </div>
        </div>
        <div class="news-body__content">
            <!-- Solo mostrar el título cuando NO esté en "todos" -->
            <div v-if="filtered !== 'all'" class="edc-section-head">
                <h1 class="edc-section-head__title">Noticias</h1>
                <p class="edc-section-head__description">
                    En los diferentes municipios del Cesar puedes encontrar noticias relevantes.
                </p>
            </div>
            <div class="edc-selector">
                <select name="municipio_selector" id="municipio_selector" @change="onFilterMunicipio()">
                    <option :value="municipio.code" :key="municipio.code" v-for="municipio in municipio_list">{{ municipio.name }}</option>
                </select>
            </div>
            <!-- Grid de imágenes destacadas cuando está en "todos" -->
            <div v-if="filtered === 'all'" class="featured-images-grid">
                <h2 class="grid-title">Noticias destacadas del Cesar</h2>
                <div class="images-grid">
                    <div 
                        v-for="item in featuredImages" 
                        :key="`featured-${item.id}`"
                        class="image-card"
                        @click="openImageModal(item)"
                    >
                        <img 
                            :src="item.image" 
                            :alt="item.title" 
                            class="grid-image"
                            @load="onImageLoad($event, item)"
                        />
                        <div class="image-overlay">
                            <h3 class="image-title">{{ item.title }}</h3>
                            <p class="image-description">{{ item.description }}</p>
                            <a v-if="item.link" :href="item.link" target="_blank" class="image-link" @click.stop>
                                {{ item.linkText || 'Más información' }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Modal para expandir imágenes -->
            <div v-if="showImageModal" class="image-modal" @click="closeImageModal">
                <div class="modal-backdrop"></div>
                <div class="modal-content" @click.stop>
                    <button class="modal-close" @click="closeImageModal">&times;</button>
                    <img 
                        :src="selectedImage.image" 
                        :alt="selectedImage.title" 
                        class="modal-image"
                    />
                    <div class="modal-info">
                        <h3 class="modal-title">{{ selectedImage.title }}</h3>
                        <p class="modal-description" v-if="selectedImage.description">{{ selectedImage.description }}</p>
                        <a v-if="selectedImage.link" :href="selectedImage.link" target="_blank" class="modal-link">
                            {{ selectedImage.linkText || 'Más información' }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="news-list">
                <EDCNew 
                v-for="single in news"
                :key="single.id"
                :id="single.id" 
                :date="formatDate(single.created)" 
                :name="single.title" 
                :image="single.image" />
            </div>
            <EDCButton label="Cargar más" v-show="next" @click="onNextButton()" />
        </div>
    </div>
    <EDCFooter />
    <EDCMobileNav />
</template>

<script>
import EDCHeader from '../components/Header.vue';
import EDCFooter from '../components/Footer.vue';
import EDCMobileNav from '../components/MobileNav.vue';
import EDCNew from '../components/New.vue';
import EDCButton from '../components/Button.vue';
import { Spinner } from '@/scripts/open-spinner';

import { MUNICIPIO_CODES_ALL } from '../scripts/municipio-codes';
import { NewsAPI } from '@/services/news';

export default {
    name: "edc-businesses-view",
    components: {
        EDCHeader,
        EDCFooter,
        EDCMobileNav,
        EDCNew,
        EDCButton
    },
    data() {
        return {
            filtered: 'all',
            news: [],
            next: null,
            municipio_list: MUNICIPIO_CODES_ALL,
            showImageModal: false,
            selectedImage: null,
            featuredImages: [
                {
                    id: 'featured-1',
                    image: 'https://almacenamientounicesar.blob.core.windows.net/enamoratedelcesar/assets/media/media/business/image_item/Encuentro_intercluster.jpeg',
                    title: 'Tercer InterClúster 2025',
                    description: 'Un espacio estratégico diseñado para impulsar la innovación, la competitividad y la articulación empresarial de nuestra región.',
                    link: 'https://docs.google.com/forms/d/1uboqIjBLi2XDb5RQz37X5gjmYaz2IDsy_yrAuHbJxdQ/viewform?edit_requested=true',
                    linkText: 'Inscribirse aquí'
                },
                {
                    id: 'featured-2',
                    image: 'https://almacenamientounicesar.blob.core.windows.net/enamoratedelcesar/assets/media/media/business/image_item/ExpoCorpocesar2025.jpg',
                    title: 'Expo Corpocesar 2025',
                    description: 'Un espacio diseñado para conectar mentes innovadoras y celebrar la sostenibilidad en el Cesar. '
                },
                {
                    id: 'featured-3',
                    image: 'https://almacenamientounicesar.blob.core.windows.net/enamoratedelcesar/assets/media/media/business/image_item/ReconocimientoMeritoEmpresarial2025.jpg',
                    title: 'XV Reconocimiento al Mérito Empresarial Julio Villazón Baquero',
                    description: 'Si eres parte del tejido empresarial que impulsa el crecimiento del Cesar, esta es tu oportunidad de destacar.',
                    link: 'https://docs.google.com/forms/d/e/1FAIpQLSekH0fS_aw_tkvLAmufW619pAUP5VvMFW1ryqCzO6vFXqjd8g/viewform?usp=preview',
                    linkText: 'Inscribirse aquí'
                }
            ]
        }
    },
    mounted() {
        this.getAllNews()
        document.addEventListener('keydown', this.handleKeydown)
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.handleKeydown)
    },
    methods: {
        getAllNews() {
            Spinner.show()
            NewsAPI.allNews().then(data => {
                this.news = data.results;
                this.next = data.next;
                Spinner.hide()
            })
        },
        getFilteredNews(municipio_name) {
            NewsAPI.newsFilteredByMunicipio(municipio_name).then(data => {
                this.news = data.results;
                this.next = data.next;
            })
        },
        onFilterMunicipio(municipio_name) {
            const selector = document.querySelector("#municipio_selector")
            
            if (!municipio_name) {
                this.filtered = selector.value;
            } else {
                this.filtered = municipio_name;
                selector.value = this.filtered;
            }

            if (this.filtered === "valledupar") {
                window.location.href = "https://valledupar.enamoratedelcesar.co/";
                return;
            }
            
            if (this.filtered === "aguachica") {
                window.location.href = "https://aguachica.enamoratedelcesar.co/";
                return;
            }

            if (this.filtered === "agustin_codazzi") {
                window.location.href = "https://agustin-codazzi.enamoratedelcesar.co/";
                return;
            } 

            if (this.filtered === "astrea") {
                window.location.href = "https://astrea.enamoratedelcesar.co/";
                return;
            } 

            if (this.filtered === "becerril") {
                window.location.href = "https://becerril.enamoratedelcesar.co/";
                return;
            } 

            if (this.filtered === "bosconia") {
                window.location.href = "https://bosconia.enamoratedelcesar.co/";
                return;
            } 

            if (this.filtered === "chimichagua") {
                window.location.href = "https://chimichagua.enamoratedelcesar.co/";
                return;
            } 

            if (this.filtered === "chiriguana") {
                window.location.href = "https://chiriguana.enamoratedelcesar.co/";
                return;
            } 

            if (this.filtered === "curumani") {
                window.location.href = "https://curumani.enamoratedelcesar.co/";
                return;
            } 

            if (this.filtered === "el_copei") {
                window.location.href = "https://el-copey.enamoratedelcesar.co/";
                return;
            } 
            
            if (this.filtered === "el_paso") {
                window.location.href = "https://el-paso.enamoratedelcesar.co/";
                return;
            } 

            if (this.filtered === "gamarra") {
                window.location.href = "https://gamarra.enamoratedelcesar.co/";
                return;
            } 

            if (this.filtered === "gonzalez") {
                window.location.href = "https://gonzalez.enamoratedelcesar.co/";
                return;
            } 

            if (this.filtered === "la_gloria") {
                window.location.href = "https://la-gloria.enamoratedelcesar.co/";
                return;
            } 

            if (this.filtered === "la_jagua_de_ibirico") {
                window.location.href = "https://la-jagua-de-ibirico.enamoratedelcesar.co/";
                return;
            }            

            if (this.filtered === "la_paz") {
                window.location.href = "https://la-paz.enamoratedelcesar.co/";
                return;
            }                    

            if (this.filtered === "manaure") {
                window.location.href = "https://manaure-balcon-del-cesar.enamoratedelcesar.co/";
                return;
            }  

            if (this.filtered === "pailitas") {
                window.location.href = "https://pailitas.enamoratedelcesar.co/";
                return;
            }  

            if (this.filtered === "pelaya") {
                window.location.href = "https://pelaya.enamoratedelcesar.co/";
                return;
            }  

            if (this.filtered === "pueblo_bello") {
                window.location.href = "https://pueblo-bello.enamoratedelcesar.co/";
                return;
            }  

            if (this.filtered === "rio_de_oro") {
                window.location.href = "https://rio-de-oro.enamoratedelcesar.co/";
                return;
            }  

            if (this.filtered === "san_alberto") {
                window.location.href = "https://san-alberto.enamoratedelcesar.co/";
                return;
            }  

            if (this.filtered === "san_diego") {
                window.location.href = "https://san-diego.enamoratedelcesar.co/";
                return;
            }  

            if (this.filtered === "san_martin") {
                window.location.href = "https://san-martin.enamoratedelcesar.co/";
                return;
            }  

            if (this.filtered === "tamalameque") {
                window.location.href = "https://tamalameque.enamoratedelcesar.co/";
                return;
            }

            if (this.filtered === "all") {
                this.getAllNews()
            } else {
                this.getFilteredNews(this.filtered)
            } 
        },
        onNextButton() {
            fetch(this.next)
            .then(res => res.json())
            .then(data => {
                const results = data.data.results;

                if (results) {
                    this.next = data.data.next;

                    results.forEach(exp => {
                        this.experiences.push(exp)
                    })
                }
            })
        },
        formatDate(value){
            if (!value) return '';
            const withT = value.replace(' ', 'T');
            const iso = withT.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
            const d = new Date(iso);
            if (isNaN(d)) return value;
            return new Intl.DateTimeFormat('es-CO', {
                day: '2-digit',
                month: 'long',
                year: 'numeric'
            }).format(d);
        },
        // Métodos para detección dinámica de dimensiones
        onImageLoad(event, item) {
            const img = event.target;
            const aspectRatio = img.naturalWidth / img.naturalHeight;
            
            // Detectar tipo de imagen
            item.aspectRatio = aspectRatio;
            item.isPortrait = aspectRatio < 0.8; // Más alto que ancho
            item.isLandscape = aspectRatio > 1.2; // Más ancho que alto
            item.isSquare = aspectRatio >= 0.8 && aspectRatio <= 1.2; // Cuadrada
        },
        getImageClass(item) {
            if (item.isPortrait) return 'portrait';
            if (item.isLandscape) return 'landscape';
            if (item.isSquare) return 'square';
            return '';
        },
        // Métodos para el modal de imagen
        openImageModal(item) {
            this.selectedImage = item;
            this.showImageModal = true;
            document.body.style.overflow = 'hidden'; // Prevenir scroll del body
        },
        closeImageModal() {
            this.showImageModal = false;
            this.selectedImage = null;
            document.body.style.overflow = 'auto'; // Restaurar scroll del body
        },
        handleKeydown(event) {
            if (event.key === 'Escape' && this.showImageModal) {
                this.closeImageModal();
            }
        }
    }
}
</script>

<style>
/* BODY */
.news-body {
    width: 100%;
    max-width: 1000px;
    padding: 24px;
    margin: 0px auto;
    margin-bottom: 40px;
    display: flex;
    gap: 24px;
}

.news-body__left {
    min-width: 180px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    /* Hide on mobile */
    display: none;
}

.news-body__left-title {
    font-size: 1.5rem;
}

.news-municipio__list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.news-municipio {
    text-decoration: none;
    color: var(--color-dark);
    cursor: pointer;
}

.news-municipio.active {
    color: var(--color-primary);
    font-weight: bold;
}

.news-body__content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.news-body button {
    max-width: 250px;
    margin: 0 auto;
}

.news-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(235px, 1fr));
    gap: 16px;
}

/* Estilos del grid de imágenes destacadas */
.featured-images-grid {
    width: 100%;
    margin-bottom: 32px;
}

.grid-title {
    font-size: 1.8rem;
    font-weight: bold;
    color: var(--color-dark);
    margin-bottom: 24px;
    text-align: center;
}

.images-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-bottom: 32px;
}

.image-card {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    background: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.image-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.grid-image {
    width: 100%;
    height: 180px;
    object-fit: cover;
    display: block;
    transition: transform 0.3s ease;
}

.image-card:hover .grid-image {
    transform: scale(1.05);
}

.image-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.9));
    color: white;
    padding: 20px;
    transform: translateY(100%);
    transition: transform 0.3s ease;
}

.image-card:hover .image-overlay {
    transform: translateY(0);
}

.image-title {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 0 0 8px 0;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
}

.image-description {
    font-size: 0.9rem;
    margin: 0 0 12px 0;
    opacity: 0.95;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
}

.image-link {
    display: inline-block;
    background: rgb(161, 83, 170);
    color: white;
    padding: 8px 16px;
    border-radius: 6px;
    text-decoration: none;
    font-size: 0.9rem;
    font-weight: 500;
    transition: all 0.3s ease;
    margin-top: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    text-shadow: none;
}

.image-link:hover {
    background: rgb(161, 83, 170);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

/* Estilos del modal de imagen */
.image-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 80px 20px 60px 20px;
    box-sizing: border-box;
}

.modal-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 254, 236, 0.9);
    backdrop-filter: blur(10px);
}

.modal-content {
    position: relative;
    max-width: 80vw;
    max-height: 80vh;
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    margin: auto;
    transform: translateY(0);
}

.modal-close {
    position: absolute;
    top: 15px;
    right: 15px;
    background: rgba(255, 255, 255, 0.9);
    color: #333;
    border: none;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    font-size: 1.5rem;
    cursor: pointer;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.modal-close:hover {
    background: rgba(255, 255, 255, 1);
    transform: scale(1.05);
}

.modal-image {
    width: 100%;
    height: auto;
    max-height: 60vh;
    object-fit: contain;
    display: block;
    margin: 0 auto;
}

.modal-info {
    padding: 20px;
    background: white;
}

.modal-title {
    font-size: 1.5rem;
    font-weight: bold;
    margin: 0 0 2px 0;
    color: var(--color-dark);
}

.modal-description {
    font-size: 1rem;
    color: #666;
    margin: 0 0 15px 0;
    font-style: italic;
}

.modal-link {
    display: block;
    background: var(--color-primary);
    color: white;
    padding: 12px 24px;
    border-radius: 8px;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 500;
    transition: all 0.3s ease;
    margin: 20px auto 15px auto;
    text-align: center;
    max-width: 200px;
}

.modal-link:hover {
    background: var(--color-primary-dark, rgb(161, 83, 170));
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.modal-date {
    font-size: 0.9rem;
    color: #888;
    margin: 0;
}

@media (min-width: 800px) {
    .news-body__left { display: flex }
    .news-body__content .edc-selector { display: none }
    .images-grid {
        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
        gap: 24px;
    }
    .grid-image {
        height: 220px;
    }
    .grid-title {
        font-size: 2rem;
    }
}

@media (max-width: 480px) {
    .images-grid {
        grid-template-columns: 1fr;
        gap: 16px;
    }
    .grid-image {
        height: 160px;
    }
    .grid-title {
        font-size: 1.5rem;
    }
    
    /* Modal responsive */
    .image-modal {
        padding: 15px;
        align-items: center;
        justify-content: center;
    }
    .modal-content {
        max-width: 95vw;
        max-height: 85vh;
        margin: auto;
    }
    .modal-image {
        max-height: 50vh;
    }
    .modal-info {
        padding: 15px;
    }
    .modal-title {
        font-size: 1.2rem;
    }
    .modal-description {
        font-size: 0.9rem;
    }
    .modal-close {
        width: 35px;
        height: 35px;
        font-size: 1.2rem;
    }
}
</style>